import { useTranslation } from 'react-i18next';

import type { InvoiceTemplateIntervalStatus } from '~/api/invoiceTemplates/types';
import type { IconName } from '~/components/Icon/Icon';
import type { statusColorThemes } from '~/styles/themes.css';

import { StatusTag, Tooltip } from '~/components';

type StatusEntry = {
  icon: IconName;
  status: keyof typeof statusColorThemes;
};

const statusMap: Record<InvoiceTemplateIntervalStatus, StatusEntry> = {
  Live: { icon: 'Play', status: 'success' },
  Paused: { icon: 'Pause', status: 'warning' },
};

type Props = {
  status: InvoiceTemplateIntervalStatus;
};

export const InvoiceTemplateStatusTag = ({ status }: Props) => {
  const { icon, status: statusTheme } = statusMap[status];
  const { t } = useTranslation(['invoiceTemplates']);

  return (
    <Tooltip content={t(`invoiceTemplates:details.intervalStatusTooltip.${status}`)}>
      <StatusTag icon={icon} label={t(`invoiceTemplates:terminology.intervalStatus.cases.${status}`)} status={statusTheme} />
    </Tooltip>
  );
};
